import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import HeaderWithStatus from '../../../../common/Headers/HeaderWithStatus/HeaderWithStatus';
import { ExpenseHeaderConfig } from './ExpenseHeaderConfig';
import { useWindowSize } from '../../../../../utils/hooks';
import classes from './ExpenseHeader.module.scss';
import { responsiveSizeTimesheet } from '../../../../../utils/constants';
// eslint-disable-next-line import/no-cycle
import TimeandExpenseActions from '../../../../common/buttons/TimeandExpenseActions/TimeandExpenseActions';

export default function ExpenseHeader({ error, expense, save, submit, approve, reject, saving, rejecting }) {
  const { t } = useTranslation();
  const size = useWindowSize();

  const isApprover = useSelector((state) => state.accessToParts.tAndEApprover);
  const expenseHeaderConfig = ExpenseHeaderConfig(t, expense, '', size, classes, isApprover);
  const { dataStatusLogic, headerLeft, keyValueLabels } = expenseHeaderConfig;

  const expenseActions = () => {
    return (
      size.width > responsiveSizeTimesheet && (
        <TimeandExpenseActions
          error={error}
          saving={saving}
          rejecting={rejecting}
          save={save}
          submit={submit}
          approve={approve}
          reject={reject}
          isApprover={isApprover}
          status={expense?.Status?.Status}
        />
      )
    );
  };
  return (
    <HeaderWithStatus
      data={expense}
      dataStatusLogic={dataStatusLogic}
      leftContent={headerLeft}
      keyValueLabel={keyValueLabels}
      actionsContainer={expenseActions()}
      isApprover={isApprover}
    />
  );
}
